import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=785c6018&scoped=true"
import script from "./DownloadCenter.vue?vue&type=script&lang=js"
export * from "./DownloadCenter.vue?vue&type=script&lang=js"
import style0 from "./DownloadCenter.vue?vue&type=style&index=0&id=785c6018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785c6018",
  null
  
)

export default component.exports